module.exports = __webpack_public_path__ + "1791188489487/images/asia.91a3dee.png";